<template>
  <master-page>
    <v-card class="mt-4">

      <v-card-title class="pa-0 sticky">
        <v-toolbar color="primary">

          <v-toolbar-title>
            <v-icon large left color="white">mdi-domain</v-icon>
            <span class="title font-weight-light" style="color: white">Cadastro Organização - {{ item.isJuridica ? 'Pessoa Jurídica' : 'Pessoa Física' }}</span>
          </v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn color="white" text @click="Salvar()" :disabled="!valid">Salvar</v-btn>
          </v-toolbar-items>

        </v-toolbar>
      </v-card-title>

      <v-card-text class="my-3">

        <v-form id="form" ref="form" v-model="valid" lazy-validation >
          <v-row>                    
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="item.cnpj" label="CPF/CNPJ" disabled dense outlined/>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="item.nome" label="Nome / Razão Social" :rules="fieldRules" :counter="300" maxlength="300" dense outlined/>
            </v-col>           
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="item.fantasia" label="Apelido / Nome Fantasia" :counter="255" maxlength="255" dense outlined/>
            </v-col>   
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="item.insc_Estadual" label="Inscrição Estadual" :counter="300" maxlength="300" dense outlined/>
            </v-col>             
            <v-col cols="12" sm="6" md="4">
              <v-text-field v-model="item.insc_Municipal" label="Inscrição Municipal" :counter="300" maxlength="300" dense outlined/>
            </v-col>           
          </v-row>

          <fieldset class="pa-4">
            <legend>Endereço: </legend>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="item.logradouro" label="Logradouro" :rules="fieldRules" :counter="300" maxlength="300" dense outlined/>
                </v-col>   
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="item.cep" label="CEP" :rules="fieldRules" v-mask="mskCep" @blur="ObterEndereco(item.cep)" dense outlined/>
                </v-col> 
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="item.bairro" label="Bairro" :rules="fieldRules" :counter="300" maxlength="300" dense outlined/>
                </v-col>  
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete v-model="item.estado" label="Estado" :rules="fieldRules" :items="estados" item-value="key" item-text="value" dense outlined/>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete v-model="item.municipioId" label="Município" :rules="fieldRules" :items="municipios" item-value="id" item-text="nome" dense outlined/>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="!item.municipioId">
                  <v-text-field v-model="item.cidade" label="Cidade" :rules="fieldRules" :counter="300" maxlength="300" dense outlined/>
                </v-col>  
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="item.pais" label="País" :rules="fieldRules" :counter="45" maxlength="45" dense outlined/>
                </v-col>  
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="item.telefone1" label="Telefone 1" :rules="fieldRules" dense outlined/>
                </v-col>  
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="item.telefone2" label="Celular" dense outlined/>
                </v-col>  
              </v-row>
          </fieldset>

          <fieldset class="pa-4">
            <legend>Contato: </legend>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="item.responsavel" label="Nome" :counter="300" maxlength="300" dense outlined/>
                </v-col>   
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="item.responsavel_Tel" label="Telefone" :rules="fieldRules" dense outlined/>
                </v-col>             
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="item.responsavel_Email" label="Email" :rules="fieldRules" :counter="300" maxlength="300" dense outlined/>
                </v-col>           
              </v-row>
          </fieldset>
          
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <div v-if="logo" style="justify-content: center ; display: flex"  class="my-3">
                <v-img :src="logo" height="100" max-width="260" contain/>
              </div>
              <v-file-input label="Logo" v-model="logoEnviar" class="mb-n5" accept=".png" dense outlined/>   
              <span style="color: red">*O upload será realizado no momento da inclusão ou alteração.</span>           
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <div v-if="assinatura" style="justify-content: center ; display: flex"  class="my-3">
                <v-img :src="assinatura" height="100" max-width="260" contain/>
              </div>
              <v-file-input label="Assinatura" v-model="assinaturaEnviar" class="mb-n5" accept=".png" dense outlined/>
              <span style="color: red">*O upload será realizado no momento da inclusão ou alteração.</span>
            </v-col>
          </v-row>

        </v-form>

      </v-card-text>

    </v-card>

    <v-overlay :value="primeiraCarga">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </master-page>
</template>

<script>
import Empresa from '@/core/domain/geral/Empresa'
import { EmpresaService, EstadoEnumService, EnderecoService } from '../../../core/services/geral'

export default {
  watch:{
    item: function() {
      if('form' in this.$refs)
        this.$refs.form.resetValidation();
      this.primeiraCarga = false;
    },
    "item.estado": function(val){
      if(!val) return;
      new EnderecoService().ObterMunicipios(this.item.estado).then(
        res => {
          this.municipios = res.data;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      );
    },
  },
  data:() => ({
    item: new Empresa(),
    service: new EmpresaService(),
    sessionApp: {},
    fieldRules: [
      v => !!v || 'Campo obrigatório'
    ],
    valid: true,
    primeiraCarga: false,
    logo: null,
    assinatura: null,
    logoEnviar: null,
    assinaturaEnviar: null,
    estados: [],
    municipios: [],
    mskCep: process.env.VUE_APP_MSK_CEP,
  }),
  methods: {
    ObterEndereco(cep){
      const enderecoService = new EnderecoService();
      enderecoService.ObterPorCep(cep).then(
        res => {
          let endereco = res.data;
          if (endereco) {
            this.item.logradouro = "";
            this.item.bairro = "";
            this.item.cidade = "";
            this.item.estado = "";
            this.item.pais = "";
            this.item.logradouro = endereco.logradouro;
            this.item.bairro = endereco.bairro;
            this.item.cidade = endereco.municipio;
            this.item.municipioId = endereco.municipioId;
            this.item.estado = endereco.estado;
            this.item.pais = endereco.pais;
          }
        },
        err => {
          this.$swal('Aviso', err.message, 'error');
        }
      );
    },
    Carregar(){

      this.primeiraCarga = true;

      this.service.ObterPorId(this.sessionApp.empresaId).then(
        res=>{
          this.item = new Empresa(res.data);
          this.service.GetAssinatura(this.sessionApp.empresaId).then(
            res =>{
              this.assinatura = res.data
            }
          )
          this.service.GetLogo(this.sessionApp.empresaId).then(
            res =>{
              this.logo = res.data
            }
          )
        },
        err=>{
          this.$swal('Aviso', err.response.data, 'error')
        }
      )

      const estadoEnumService = new EstadoEnumService();
      estadoEnumService.Listar().then(
        res => {
          this.estados = res.data;
        },
        err => {
          this.$swal('Aviso', err.message, 'error');
        }
      );
    },
    Salvar(){
      if (this.$refs.form.validate()) {

        let modelo = new Empresa(this.item);

        this.service.Salvar(modelo)
        .then(
          res => {
            if(this.logoEnviar && this.assinaturaEnviar){

              return new Promise(async (resolve,reject) => {
                this.EnviarLogo(res.data.id ? res.data.id : this.item.id).then(
                  res => resolve(res),
                  err => reject(err)
                );
                this.EnviarAssinatura(res.data.id ? res.data.id : this.item.id).then(
                  res => resolve(res),
                  err => reject(err)
                );
              }).then(
                res=>{

                },
                err=>{
                  if (err.response.status == 400) {
                    this.$swal('Aviso', err.response.data.title, 'warning')    
                  }
                  else {
                    this.$swal('Aviso', err.response.data, 'error')
                  }
                }
              ).finally(() =>{
                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                this.$emit('salvou');
                this.assinaturaEnviar = null;
                this.logoEnviar = null;
                this.Carregar();
              })
            }
            else if(!this.logoEnviar && this.assinaturaEnviar){
              this.EnviarAssinatura(res.data.id ? res.data.id : this.item.id).then(
                res=>{
                  this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                  this.$emit('salvou');
                  this.Carregar();
                },
                err=>{
                  if (err.response.status == 400) {
                    this.$swal('Aviso', err.response.data.title, 'warning')    
                  }
                  else {
                    this.$swal('Aviso', err.response.data, 'error')
                  }
                }
              ).finally(() =>{
                this.assinaturaEnviar = null;
              })
            }
            else if(this.logoEnviar && !this.assinaturaEnviar){
              this.EnviarLogo(res.data.id ? res.data.id : this.item.id).then(
                res=>{
                  this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                  this.$emit('salvou');
                  this.Carregar();
                },
                err=>{
                  if (err.response.status == 400) {
                    this.$swal('Aviso', err.response.data.title, 'warning')    
                  }
                  else {
                    this.$swal('Aviso', err.response.data, 'error')
                  }
                }
              ).finally(()=>{
                this.logoEnviar = false;
              })
            }
            else{
              this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
              this.$emit('salvou');
            }            
          }, 
          err =>  {
            if (err.response.status == 400) {
              this.$swal('Aviso', err.response.data.title, 'warning')    
            }
            else {
              this.$swal('Aviso', err.response.data, 'error')
            }
          }
        );
      }
    },
    async EnviarLogo(id){            
      return new Promise(async (resolve, reject) => {
        let arquivo = await this.LerLogo(this.logoEnviar);
        this.service.EnviarLogo(id, arquivo).then(
          res => resolve(res),
          err => reject(err)
        )
      });
    },
    async LerLogo(arquivo){
      return new Promise((resolve, reject) => {
        let fr = new FileReader();    
        fr.onload = (arquivo) => {
          resolve(arquivo.target.result);
        };    
        fr.readAsArrayBuffer(arquivo);
      });
    },
    async EnviarAssinatura(id){            
      return new Promise(async (resolve, reject) => {
        let arquivo = await this.LerAssinatura(this.assinaturaEnviar);
        this.service.EnviarAssinatura(id, arquivo).then(
          res => resolve(res),
          err => reject(err)
        )
      });
    },
    async LerAssinatura(arquivo){
      return new Promise((resolve, reject) => {
        let fr = new FileReader();    
        fr.onload = (arquivo) => {
          resolve(arquivo.target.result);
        };    
        fr.readAsArrayBuffer(arquivo);
      });
    }
  },
  mounted() {
    this.sessionApp = JSON.parse(localStorage.sessionApp);

    this.Carregar();
  }
}
</script>

<style>
  .sticky{
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
    z-index: 5;
  }
</style>
